import React from 'react'
import './filterSidebar.css'

// This page is a static placeholder — no train search API exists yet, so every
// value here is hardcoded to match the reference design exactly (no state,
// no onChange, nothing actually filters). Once a train API is available, this
// can be wired up the same way filterSidebar.jsx (flight) / busFilterSidebar.jsx are.

const QUICK_FILTERS = [
    { key: 'ac', label: 'AC', count: 61 },
    { key: 'available', label: 'Available', count: 61 },
    { key: 'departureAfter6pm', label: 'Departure after 6 PM', count: 25 },
    { key: 'arrivalBefore12pm', label: 'Arrival before 12 PM', count: 31 },
]

const TICKET_TYPES = [
    { key: 'freeCancellation', label: 'Free Cancellation', count: 63 },
    { key: 'alternateTripPlan', label: 'Alternate Trip Plan (previously Trip Guarantee)', count: 64 },
]

const QUOTAS = [
    { key: 'general', label: 'General Quota', count: 64, checked: true },
    { key: 'ladies', label: 'Ladies Quota', count: 64 },
    { key: 'tatkal', label: 'Tatkal', count: 64, checked: true },
]

const JOURNEY_CLASSES = [
    { key: '1a', label: '1st Class AC - 1A', count: 36 },
    { key: '2a', label: '2nd Class AC - 2A', count: 45 },
    { key: '3a', label: '3rd Class AC - 3A', count: 53 },
    { key: 'sl', label: 'Sleeper - SL', count: 47 },
    { key: '2s', label: 'Second Sitting - 2S', count: 2 },
    { key: 'cc', label: 'AC Chair Car - CC', count: 7 },
    { key: '3e', label: 'AC three tier(economy) - 3E', count: 31 },
    { key: 'ec', label: 'Executive Chair Car - EC', count: 6 },
]

const TIME_SLOTS = [
    { key: '12to6am', label: '12am - 6am' },
    { key: '6to12pm', label: '6am - 12pm' },
    { key: '12to6pm', label: '12pm - 6pm' },
    { key: '6to12am', label: '6pm - 12am' },
]

const TRAIN_TYPES = [
    { key: 'st', label: 'Special Tatkal Trains - ST', count: 10 },
    { key: 'sp', label: 'Special Trains - SP', count: 10 },
    { key: 'g', label: 'Garib Rath - G', count: 2 },
    { key: 'o', label: 'Others - O', count: 38 },
    { key: 'd', label: 'Duronto - D', count: 1 },
    { key: 'r', label: 'Rajdhani - R', count: 6 },
    { key: 's', label: 'Shatabdi - S', count: 6 },
    { key: 'mex', label: 'MEX - MEX', count: 1 },
]

const DELHI_STATIONS = [
    { key: 'ndls', label: 'New Delhi - NDLS', count: 32 },
    { key: 'anvt', label: 'Anand Vihar Trm - ANVT', count: 18 },
    { key: 'dli', label: 'Delhi - DLI', count: 7 },
    { key: 'andi', label: 'Adrsh Ngr Delhi - ANDI', count: 2 },
    { key: 'der', label: 'Dadri - DER', count: 1 },
    { key: 'szm', label: 'Subzi Mandi - SZM', count: 3 },
    { key: 'hpu', label: 'Hapur - HPU', count: 1 },
]

const KANPUR_STATIONS = [
    { key: 'cnb', label: 'Kanpur Central - CNB', count: 52 },
    { key: 'goy', label: 'Govindpuri - GOY', count: 12 },
]

const TrainFilterSidebar = () => {
    return (
        <div className='filterSidebar'>
            <div className='filterSidebarHead'>
                <div className='filterSidebarTitle'>Filters</div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Quick Filters</div>
                <div className='filterList'>
                    {QUICK_FILTERS.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div className='filterCheckLabel'>{item.label}</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{item.count}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Ticket Types</div>
                <div className='filterList'>
                    {TICKET_TYPES.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div className='filterCheckLabel'>{item.label}</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{item.count}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Quota</div>
                <div className='filterList'>
                    {QUOTAS.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div className='filterCheckLabel'>{item.label}</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{item.count}</span>
                                <input type='checkbox' defaultChecked={item.checked} readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Journey Class Filters</div>
                <div className='filterList'>
                    {JOURNEY_CLASSES.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div className='filterCheckLabel'>{item.label}</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{item.count}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Arrival in Kanpur</div>
                <div className='slotGrid'>
                    {TIME_SLOTS.map((slot) => (
                        <div key={slot.key} className='slotCard'>
                            <div className='slotLabel'>{slot.label}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Departure from Delhi</div>
                <div className='slotGrid'>
                    {TIME_SLOTS.map((slot) => (
                        <div key={slot.key} className='slotCard'>
                            <div className='slotLabel'>{slot.label}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Train Types</div>
                <div className='filterList'>
                    {TRAIN_TYPES.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div className='filterCheckLabel'>{item.label}</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{item.count}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Stations in Delhi</div>
                <div className='filterList'>
                    {DELHI_STATIONS.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div className='filterCheckLabel'>{item.label}</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{item.count}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Stations in Kanpur</div>
                <div className='filterList'>
                    {KANPUR_STATIONS.map((item) => (
                        <label className='filterCheckRow' key={item.key}>
                            <div className='filterCheckLabel'>{item.label}</div>
                            <div className='filterCheckRight'>
                                <span className='filterCheckPrice'>{item.count}</span>
                                <input type='checkbox' readOnly />
                            </div>
                        </label>
                    ))}
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Train Price</div>
                <div className='rangeSlider'>
                    <div className='rangeSlider__track' />
                    <div className='rangeSlider__range' style={{ left: '0%', right: '0%' }} />
                    <input type='range' min={9199} max={35867} defaultValue={9199} readOnly />
                    <input type='range' min={9199} max={35867} defaultValue={35867} readOnly />
                </div>
                <div className='rangeLabels'>
                    <span>₹9,199</span>
                    <span>₹35,867</span>
                </div>
            </div>

            <div className='filterSection'>
                <div className='filterSectionTitle'>Duration</div>
                <div className='rangeSlider'>
                    <div className='rangeSlider__track' />
                    <div className='rangeSlider__range' style={{ left: '0%', right: '0%' }} />
                    <input type='range' min={2} max={28} defaultValue={2} readOnly />
                    <input type='range' min={2} max={28} defaultValue={28} readOnly />
                </div>
                <div className='rangeLabels'>
                    <span>2h</span>
                    <span>28h</span>
                </div>
            </div>
        </div>
    )
}

export default TrainFilterSidebar
